import {
  Autocomplete, Box, Button, Chip, FormControl, IconButton, InputAdornment, InputLabel,
  MenuItem, Select, Stack, TextField, Tooltip, Typography, Tabs, Tab,
} from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { Colors } from '../../../../Styles/Colors';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

class DocTestRight extends Component {
  constructor(props) {
    super(props)
    this.state = {
      clinicId: localGetItem('SelectedDoctorClinicId'),
      labTestName: [],
      specialData: [],
      specialTestList: [],
      searchSetName: "",
      RadTestName: [],
      selectedTestName: [],
      selectedRadName: [],
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      specialLoad: false, 
      appointment_id: this.props.PatientData?.appointment_id,
      patient_id: this.props.PatientData?.patient_id
    }
  }

  componentDidMount() {
    this.getLabTestData()
    this.getRadTestData()
  }

  getLabTestData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_TEST_LABTEST + `?clinic_id=${this.state.clinicId}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              labTestName: response.data.data,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getRadTestData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_TEST_RADTEST + `?clinic_id=${this.state.clinicId}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              RadTestName: response.data.data,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }


  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  ClearData() {
    this.setState({
      specialData: [],
      specialTestList: [],
      selectedTestName: [],
      selectedRadName: [],
      searchSetName: "",
    })
  }


  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }




  getSpecialTestList = () => {
    try {
      this.setState({ specialLoad: true })
      let url = Serviceurls.DOC_DOCTOR_NOTES_SPECIAL_TEST_SEARCH + `?search=${this.state.searchSetName}`;
      RestAPIService.getAll(url)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              specialTestList: response.data.data,
              specialLoad: false
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ specialLoad: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ specialLoad: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ specialLoad: false })
      this.errorMessage(error.message)
    }
  }



  checkValidate = () => {
    try {
      let validate = null
      let states = this.state
      if (states.selectedLabName === '') {
        validate = 'Select Lab Name'
      } else if (states.searchSetName) {
        validate = 'Press "Enter" to add the Special Test value before clicking Add'
      } else if ((states.selectedTestName?.length > 0) || (states.selectedTestGroup?.length > 0) || (states.specialData?.length > 0) || (states?.testPackage?.length > 0)) {
        validate = null
      } else {
        validate = 'Select atleast one test'
      }
      return validate;
    } catch (error) {
      this.errorMessage(error.message)
    }
  }



  checkValidation = () => {
    try {
      let message = null;
      if (CommonValidation.removeSpace(this.state.searchSetName) !== '') {
        this.state.specialData?.forEach(element => {
          if ((element?.name === this.state.searchSetName?.name && element?.name) || (element === this.state.searchSetName && element)) {
            message = 'Special test already exists'
          }
        })
      } else {
        message = 'Select or Enter Special Test'
      }
      return message;
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  addSpecialTest = () => {
    try {
      let validation = this.checkValidation()
      if (validation === null) {
        let data = CommonValidation.updateOrInsertList(this.state.specialData, CommonValidation.removeSpace(this.state.searchSetName))
        this.setState({
          specialData: data
        }, () => {
          this.setState({ searchSetName: '', specialTestList: [] })
        })
      } else {
        this.errorMessage(validation)
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  postTestDatas = () => {
    try {
      let states = this.state;
      if (states.selectedTestName?.length === 0 && states.selectedRadName?.length === 0 && states.specialData?.length === 0) {
        this.errorMessage('Select at least one test');
      } else {
        let specialTests = [];
        this.state.specialData?.forEach(element => {
          specialTests?.push({
            id: element?.id ? element?.id : null,
            name: element?.name ? element?.name : element
          })
        })
  
        let data = {
          "lab_tests": states.selectedTestName,
          "radiology_service": states.selectedRadName,
          "special_tests": specialTests,
          "appointment_id": this.state.appointment_id,
          "patient_id": this.state.patient_id
        };
        RestAPIService.create(data, Serviceurls.DOC_TEST_POST)
          .then(response => {
            if (response?.data?.status === 'success') {
              this.successMessage(response.data.message);
              this.ClearData();
              this.props.CallgetApi('test')
            } else {
              this.errorMessage(response.data.message);
            }
          }).catch(error => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.response.data.message);
            } else {
              this.errorMessage(error.message);
            }
          });
      }
    } catch (error) {
      this.errorMessage(error.message);
    }
  }

      renderSpecialTest = () => {
      return (<Box component={'div'} emed_tid="doc_test_right_special_test_box">
        <Box component={'div'} mt={'0.5vw'} emed_tid="doc_test_right_special_test_label_box">
          <Typography fontSize={'0.8vw'} fontWeight={600} color={Colors.SecondaryText} emed_tid="doc_test_right_special_test_label">Special Test</Typography>
        </Box>
        <Box component={'div'} display={'flex'} mt={'0.5vw'} emed_tid="doc_test_right_special_test_autocomplete_box">
          <Autocomplete
            emed_tid="doc_test_right_special_test_autocomplete"
            clearIcon
            size='small'
            freeSolo
            sx={{ width: '25vw' }}
            value={this.state.searchSetName}
            options={this.state.specialTestList}
            getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.name}
            onChange={(e, newValue) => {
              this.setState({
                searchSetName: newValue
              }, () => {
                if (CommonValidation.removeSpace(this.state.searchSetName?.name)?.length > 0) {
                  this.addSpecialTest()
                } else {
                  this.setState({ specialTestList: [] })
                }
              })
            }}
            renderInput={(params) => <TextField {...params}
              emed_tid="doc_test_right_special_test_textfield"
              onChange={(e) => {
                if (CommonValidation.removeSpace(e.target.value)?.length > 0) {
                  this.setState({
                    searchSetName: e.target.value
                  }, () => this.getSpecialTestList())
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  if (CommonValidation.removeSpace(e.target.value)?.length > 0) {
                    this.addSpecialTest()
                  } else {
                    this.errorMessage('Search or Enter Special Test')
                  }
                }
              }}
              label={'Search or Enter Special Test'}
              inputProps={{ ...params.inputProps, emed_tid: "doc_test_right_special_test_input" }} />}
          />
        </Box>
        <Box component={'div'} mr={'1vw'} mt={'1vw'} overflow={'scroll'} maxHeight={'15vw'} emed_tid="doc_test_right_special_test_chips_box">
          {
            this.state.specialData?.map((item, index) => (
              <Chip
                emed_tid={`doc_test_right_special_test_chip_${index}`}
                className='eMed_chip'
                size='small'
                label={((item.name?.length > 10) || (item?.length > 10)) ? <Tooltip placement='top' title={item?.name ? item?.name : item} emed_tid={`doc_test_right_special_test_chip_tooltip_${index}`}><Typography fontSize={'0.8vw'} textTransform={'capitalize'} emed_tid={`doc_test_right_special_test_chip_text_${index}`}>{item?.name ? (item?.name?.slice(0, 10) + '...') : (item?.slice(0, 10) + '...')}</Typography></Tooltip> : <Typography fontSize={'0.8vw'} textTransform={'capitalize'} emed_tid={`doc_test_right_special_test_chip_text_full_${index}`}>{item?.name ? item?.name : item}</Typography>}
                // variant={((item.name === this.state.selectedSetName) || (item === this.state.selectedSetName)) ? 'contained' : 'outlined'}
                variant='outlined'
                key={index}
                // onClick={() => { this.setState({ selectedSetName: item?.name ? item?.name : item, selectedSpecial: item }) }}
                color={'primary'}
                clickable
                onDelete={() => {
                  this.state.specialData?.splice(index, 1)
                  this.setState({
                    specialData: this.state.specialData
                  })
                }}
              />
            ))}
        </Box>
      </Box>)
    }

    renderLabFields = () => {
      return (<Box className="eMed_Other_DocNotes_testrgt" sx={{ marginTop: '1vw' }} emed_tid="doc_test_right_lab_fields">
        <Box component={'div'} emed_tid="doc_test_right_test_box">
          <Box component={'div'} emed_tid="doc_test_right_test_label_box">
            <Typography fontSize={'0.8vw'} fontWeight={600} color={Colors.SecondaryText} emed_tid="doc_test_right_test_label">Select Test</Typography>
          </Box>
          <Box component={'div'} mt={'0.5vw'} emed_tid="doc_test_right_test_autocomplete_box">
            <Autocomplete
              emed_tid="doc_test_right_test_autocomplete"
              size='standard'
              clearIcon
              sx={{ width: '25vw' }}
              multiple
              limitTags={3}
              options={this.state.labTestName}
              getOptionLabel={(option) =>
                typeof option === "string"
                  ? option
                  : option?.service_name || option?.package_name || "-"
              }
              renderOption={(props, option) => (
                <Box
                  component="li"
                  {...props}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    textAlign: "left",
                  }}
                  emed_tid={`doc_test_right_test_option_${option?.test_id || option?.grp_id || option?.package_id || 'unknown'}`}
                >
                  <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }} emed_tid={`doc_test_right_test_option_name_${option?.test_id || option?.grp_id || option?.package_id || 'unknown'}`}>
                    {option?.service_name || option?.package_name || "-"}
                  </Typography>
                  <Typography
                    fontSize=".8vw"
                    fontWeight="bold"
                    sx={{ width: "100%", textAlign: "left" }}
                    color={
                      option?.test_id
                        ? "#F1584A"
                        : option?.grp_id
                          ? "#29B6F6"
                          : option?.package_id
                            ? "#1E972A"
                            : "inherit"
                    }
                    emed_tid={`doc_test_right_test_option_type_${option?.test_id || option?.grp_id || option?.package_id || 'unknown'}`}
                  >
                    {option?.test_id
                      ? "Test"
                      : option?.grp_id
                        ? "Group Test"
                        : option?.package_id
                          ? "Package"
                          : ""}
                  </Typography>
                </Box>
              )}
              value={this.state.selectedTestName}
              onChange={(e, value) => {
                this.setState({
                  selectedTestName: value
                }, console.log(value))
              }}
              renderInput={(params) => <TextField {...params} emed_tid="doc_test_right_test_textfield" label='Select Test' inputProps={{ ...params.inputProps, emed_tid: "doc_test_right_test_input" }} />}
            />
          </Box>
        </Box>
        <Box component={'div'} mt={'0.5vw'} emed_tid="doc_test_right_investigation_box">
          <Box component={'div'} emed_tid="doc_test_right_investigation_label_box">
            <Typography fontSize={'0.8vw'} fontWeight={600} color={Colors.SecondaryText} emed_tid="doc_test_right_investigation_label">Select Investigation</Typography>
          </Box>
          <Box component={'div'} mt={'0.5vw'} emed_tid="doc_test_right_investigation_autocomplete_box">
            <Autocomplete
              emed_tid="doc_test_right_investigation_autocomplete"
              size='standard'
              clearIcon
              sx={{ width: '25vw' }}
              multiple
              limitTags={3}
              options={this.state.RadTestName}
              getOptionLabel={(option) =>
                typeof option === "string"
                  ? option
                  : option?.service_name || option?.package_name || "-"
              }
              renderOption={(props, option) => (
                <Box
                  component="li"
                  {...props}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    textAlign: "left",
                  }}
                  emed_tid={`doc_test_right_investigation_option_${option?.service_charge_id || option?.package_id || 'unknown'}`}
                >
                  <Typography
                    fontSize=".9vw"
                    sx={{ width: "100%", textAlign: "left" }}
                    emed_tid={`doc_test_right_investigation_option_name_${option?.service_charge_id || option?.package_id || 'unknown'}`}
                  >
                    {option?.service_name || option?.package_name || "-"}
                  </Typography>
                  <Typography
                    fontSize=".8vw"
                    fontWeight="bold"
                    sx={{
                      width: "100%",
                      textAlign: "left",
                      color: option?.service_charge_id ? "#F1584A" : "#1E972A"
                    }}
                    emed_tid={`doc_test_right_investigation_option_type_${option?.service_charge_id || option?.package_id || 'unknown'}`}
                  >
                    {`${option?.service_charge_id ? "Service" : option?.package_id ? "Package" : ""} ${option?.module_type ? ` ( ${option?.module_type} )` : ""}`}
                  </Typography>
                </Box>
              )}
              value={this.state.selectedRadName}
              onChange={(e, value) => {
                this.setState({
                  selectedRadName: value
                })
              }}
              renderInput={(params) => <TextField {...params} emed_tid="doc_test_right_investigation_textfield" label='Select Investigation' inputProps={{ ...params.inputProps, emed_tid: "doc_test_right_investigation_input" }} />}
            />
          </Box>
        </Box>
        {this.renderSpecialTest()}
      </Box>)
    }

    render() {
      const { t } = this.props
      let states = this.state
      return (
        <Box emed_tid="doc_test_right_container">
          <Typography className='eMed_refdoc_title' emed_tid="doc_test_right_title">{this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : 'Test'}</Typography>
          {this.renderLabFields()}
          <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"} emed_tid="doc_test_right_actions">
            <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.ClearData() }} emed_tid="doc_test_right_clear_btn">{t("Clear")}</Button>
            <Button variant='contained' size="small" id="eMed_Config_btn" onClick={() => { this.postTestDatas() }} emed_tid="doc_test_right_add_btn">{t("Add")}</Button>
          </Stack>
          {this.state.isErrorMsg ?
            <ToastMsg
              emed_tid="doc_test_right_error_toast"
              severity={'error'}
              msg={this.state.isErrorMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
          {this.state.successMsg ?
            <ToastMsg
              emed_tid="doc_test_right_success_toast"
              severity={'success'}
              msg={this.state.successMsgText}
              msgPop={this.msgClose.bind(this)}
            />
            : null}
        </Box>
      )
    }
  }
export default withTranslation()(DocTestRight)
